"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorLogPlugin = void 0;
var enableRaygun_1 = require("./enableRaygun");
var logError_1 = require("./logError");
// see https://vuejs.org/guide/reusability/plugins.html#writing-a-plugin
/**
 * Vue plugin for Raygun error logging.
 * @example <caption>without a configuration object (apiKey and version are set elsewhere)</caption>
 * app.use(errorLog);
 * @example <caption>with a configuration object</caption>
 * app.use(errorLog, { apiKey: "...", version: "..." });
 */
exports.errorLogPlugin = {
    /**
     * Install the plugin
     * @param app the Vue application
     * @param options optional configuration object with the following properties: apiKey, version
     */
    install: function (app) {
        var options = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            options[_i - 1] = arguments[_i];
        }
        var existingErrorHandler = app.config.errorHandler;
        app.config.errorHandler = function (err, vm, info) {
            return handleError(err, vm, info, existingErrorHandler);
        };
        var config = (options && Array.isArray(options) ? options[0] : options);
        if (config && config.apiKey && config.version) {
            (0, enableRaygun_1.enableRaygun)(config.apiKey, config.version);
        }
    }
};
function handleError(err, vm, info, existingHandler) {
    (0, logError_1.logError)(err, vm, info);
    if (existingHandler) {
        existingHandler(err, vm, info);
    }
}
//# sourceMappingURL=errorLogPlugin.js.map